import { connect } from 'react-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProduct } from 'src/redux/selectors';
import { ProductImagesCarousel } from '../components/ProductImagesCarousel';
import { actions } from '../modules/slice';

const mapStateToProps = (state: ReduxApplicationState) => ({
  product: selectProduct(state),
  currentImage: state.productImagesCarousel.currentImage,
  navigatedBy: state.productImagesCarousel.navigatedBy,
  isModalOpen: state.productImagesCarousel.isModalOpen,
});

const mapDispatchToProps = {
  setCurrentImage: actions.setCurrentImage,
  onOpenModal: actions.openModal,
  onCloseModal: actions.closeModal,
  onNextImage: actions.nextImage,
  onPrevImage: actions.prevImage,
};

export const ProductImagesCarouselContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductImagesCarousel);
